import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private storageKey = 'app_version';

  constructor(private http: HttpClient) {}

  checkVersion(url = '/assets/version.json') {
    return this.http.get<{ version: string, buildDate : string }>(url + '?t=' + new Date().getTime())
      .subscribe(latest => {
        localStorage.setItem("app_build", latest.buildDate);

        const storedVersion = localStorage.getItem(this.storageKey);

        if (!storedVersion) {
          // First access → store version
          localStorage.setItem(this.storageKey, latest.version);
          
            //since it's new feature, set all force first to old user
            // remove after 1 or 2 month. uncomment bellow
            const getLang = localStorage.getItem("language"); //default ceda 
            if(getLang){
                this.forceClearCacheAndReload(latest.version);
            }

            // //force for old user have login before
            // const latestAccessCeda = localStorage.getItem("ceda_date_access");
            // if(latestAccessCeda){
            //     this.forceClearCacheAndReload(latest.version);
            // }

        } else if (storedVersion !== latest.version) {
          // Version changed → force reload
          this.forceClearCacheAndReload(latest.version);
        }
      },
      err => {
        console.warn('[VersionCheck] Could not load version.json:', err);
        // If version.json is missing, still force reload to avoid stale cache
        this.forceClearCacheAndReload('');
      });
  }

  private forceClearCacheAndReload(newVersion: string) {

  const currentPath = window.location.pathname;

  // Define paths to skip
  const includePath = [ '/login','/dashboard','/'];
  if (includePath.includes(currentPath)) {

    this.showUpdateOverlay();

    if (newVersion) {
      localStorage.setItem(this.storageKey, newVersion);
    }

    if ('caches' in window) {
      caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
    }

    setTimeout(() => {
      const url = window.location.origin + '/?v=' + new Date().getTime();
      window.location.href = url;
    }, 2000);

  }
  }

  private showUpdateOverlay() {
    const overlay = document.createElement('div');
    overlay.id = 'update-overlay';
    overlay.innerHTML = `
      <div style="
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(255,255,255,0.85); z-index: 99999;
        display: flex; flex-direction: column;
        align-items: center; justify-content: center;
        font-family: sans-serif;
      ">
        <div style="margin-bottom: 16px; font-size: 15px; color: #444;">
          <b>Loading updates...</b>
        </div>
        <div style="width: 240px; height: 6px; background: #e0e0e0; border-radius: 3px; overflow: hidden;">
          <div id="update-progress-bar" style="
            height: 100%; width: 0%; background: #4caf50;
            border-radius: 3px; transition: width 1.2s ease;
          "></div>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);

    requestAnimationFrame(() => {
      const bar = document.getElementById('update-progress-bar');
      if (bar) bar.style.width = '90%';
    });
  }
}